import * as React from 'react';
import { observer } from 'mobx-react-lite';
import { GenericCheckbox } from '../../components';
import { InputModel } from '../../models';
import { InputWithoutSource } from '../../componentTypes';
import { useAppStore } from '../../stores';
import { ChildNodeIds, InputIds } from '../../misc';

const CreateProgramInput: InputWithoutSource = ({ input }) => {
    const { nodesStore } = useAppStore();

    const generalInformationNode = nodesStore.generalInformationNode;
    const renewalNode = generalInformationNode?.childNodes.find(
        child => child.id === ChildNodeIds.GeneralInformation.ContractRenewal
    );

    const hasBusinessId = [...(generalInformationNode?.inputs ?? []), ...(renewalNode?.inputs ?? [])].some(
        candidate => candidate.id === InputIds.GeneralInformation.BusinessId && candidate.hasValue
    );

    return <GenericCheckbox label={input.name} input={input} disabled={hasBusinessId} />;
};

CreateProgramInput.meta = {
    inputType: InputModel.name
};

export default observer(CreateProgramInput);
